export const environment = {
  mainUrl: 'https://geonavigator-uat.cbre.com/',
  baseUrl: '/',
  articleApiUrl: 'https://geonavigator-uat.cbre.com/api-comp',
  imageUrl: 'https://geonavigator-uat.cbre.com/api-images',
  indexingApiUrl: 'https://geonavigator-uat.cbre.com/api-index',
  ondemandApiUrl: 'https://geonavigator-uat.cbre.com/api-ondemand',
  educationApiUrl: 'https://geonavigator-uat.cbre.com/api-education',
  eriApiUrl: 'https://geonavigator-uat.cbre.com/api-eri',
  blsApiUrl: 'https://geonavigator-uat.cbre.com/api-bls',
  adminUrl: 'https://geonavigator-uat.cbre.com/api-admin',
  laborplanApiUrl: 'https://geonavigator-uat.cbre.com/api-laborplan',
  esriSuggestApiUrl: 'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest',
  competitionApiUrl: 'https://geonavigator-uat.cbre.com/api-comp',
  production: false,
  isResearch: true,
  uat: true,
  isInterviews: false,
  INTERVIEW_API_URL: 'https://geonavigator-uat.cbre.com/api-comp',
  THOUGHTSPOT_USERNAME: 'US_SVC_LA_TS_SF_INT',
  ANALYTICS_KEY: 'e3F324y30cELUJsJcrIdz2sWP2o1LUfD',
  GLV_HOME: 'http://glv-test.cbre.com/Home',
  puppeteerApiUrl: 'https://geonavigator-test-api.cbre.com/api/html-screenshot?code=eCYeigbRy_WQT3rNXNFtshSJhF7yfXlp7dOmDirno02OAzFuenfvsQ==',
  geoskillFaqUrl: 'https://cbre.sharepoint.com/sites/intra-AdvisoryTransactionServices/SiteAssets/Forms/AllItems.aspx?id=%2Fsites%2Fintra%2DAdvisoryTransactionServices%2FSiteAssets%2FSitePages%2FAMS%2DConsulting%2FGeoSkill%5FFAQ%2Epdf&parent=%2Fsites%2Fintra%2DAdvisoryTransactionServices%2FSiteAssets%2FSitePages%2FAMS%2DConsulting',
  ANALYTICS_UUID_API: 'https://mktgservice.cbre.com/v2/uuid-generator'
};
